<template>
    <main id="mainCtrl">
        <PromoDialog ref="dialog" url-type="clinics"/>
        <div class="promo">
            <div class="promo__data">
                <div class="promo__title">Нужны хорошие отзывы?</div>
                <div class="promo__text">
                    <p>
                        Подключите сбор отзывов для продвижения на картах, чтобы повысить рейтинг и увеличить поток пациентов.
                    </p>
                    <ul>
                        <li>Сделаем рассылку SMS по вашей базе пациентов</li>
                        <li>Опубликуем положительные отзывы о вашей клинике</li>
                        <li>Перехватим негативные отзывы и передадим вам</li>
                        <li>Повысим рейтинг на картах Яндекс и 2ГИС</li>
                        <li>Приведем в 2 раза больше пациентов с карт</li>
                    </ul>
                </div>
                <div class="promo__actions">
                    <a href="#" class="promo__btn" @click.prevent="openDialog">Подключить</a>

                    <a href="https://doctu.ru/storage.public/files/Презентация%20ДОКТУ.pdf"
                       target="_blank"
                       @click="sendMetrik('LK_PROMO_PDF')"
                       class="promo__link">
                        Скачать презентацию
                    </a>
                </div>
            </div>
            <div class="promo__img">
                <img src="/img/lustra04.svg" alt="" />
            </div>
        </div>
    </main>
</template>

<script>
import PromoDialog from "@dialogs/Promo";
import { formatPrice } from "@/global/helpers";

export default {
    components: {
        PromoDialog
    },
    props: {
        tariffPrices: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            formatPrice: formatPrice
        }
    },
    methods: {
        openDialog() {
            this.sendMetrik('LK_PROMO_BTN');
            this.$refs.dialog.show();
        },
        sendMetrik: function (action){
            const yaCounter = window['yaCounter97357971'];
            if (yaCounter !== undefined) {
                yaCounter.reachGoal(action);
            }
        }
    }
}
</script>
